// Sign-in methods that require the `email_verified` field to be true for successful authentication.
// See https://firebase.google.com/docs/rules/rules-and-auth
export const VERIFIED_EMAIL_REQUIRED = ["custom", "password", "phone"];
